import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

import Backgroundimg from '../assets/hero-background.jpg';
import LogoSVG from '../assets/BantrBoxLogo.svg';
import IOSDownloadSVG from '../assets/AppleStoreBadge.svg';
import AndroidDownloadSVG from '../assets/GooglePlayBadge.svg';

const HeroWrapper = styled.section`
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0; 
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 0;

  &:before {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 1;
    pointer-events: none;
    background:
      linear-gradient(to top, rgba(0,0,0,0.5), transparent 40%),
      linear-gradient(to bottom, rgba(0,0,0,0.5), transparent 40%);
  }

  img {
    position: relative;
    z-index: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

const ContentWrapper = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Always top for logo and bottom for text/buttons */
  height: 100%;
  width: 100%;
  padding: 20px;
`;

const LogoContainer = styled(motion.div)`
  display: flex;
  justify-content: center;
  width: 100%;

  img {
    width: 90%;
    max-width: 600px;
    height: auto;
  }
`;

const TextBlock = styled(motion.div)`
  text-align: center;
  color: #fff; /* White text */
  max-width: 600px;
  margin: 0 auto;
`;

const Subtitle = styled(motion.p)`
  font-size: 1.1rem;
  color: #fff; /* White text */
  margin-bottom: 25px;

  @media (min-width: 768px) {
    font-size: 1.25rem;
  }
`;

const ButtonGroup = styled(motion.div)`
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;

  button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;

    &:hover img {
      transform: scale(1.05);
    }
  }

  img {
    height: 40px;
    width: auto;
    transition: transform 0.3s ease;

    @media (min-width: 768px) {
      height: 50px;
    }
  }
`;

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      delayChildren: 0.3,
      staggerChildren: 0.2
    }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 }
};

const HeroSection = () => {
  return (
    <HeroWrapper>
      <Background>
        <img src={Backgroundimg} alt="Hero background" />
      </Background>

      <ContentWrapper>
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          style={{ width: '100%' }}
        >
          <LogoContainer variants={itemVariants}>
            <img src={LogoSVG} alt="BantrBox Logo" />
          </LogoContainer>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          style={{ width: '100%' }}
        >
          <TextBlock>
            <Subtitle variants={itemVariants}>
              The ultimate social platform for friendly rivalries and epic challenges.
            </Subtitle>

            <ButtonGroup variants={itemVariants}>
              <button aria-label="Download on iOS">
                <img src={IOSDownloadSVG} alt="Download on iOS" />
              </button>
              <button aria-label="Download on Android">
                <img src={AndroidDownloadSVG} alt="Download on Android" />
              </button>
            </ButtonGroup>
          </TextBlock>
        </motion.div>
      </ContentWrapper>
    </HeroWrapper>
  );
};

export default HeroSection;
